import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { AuthService } from "@core/auth.service";
import { TranslateService, TranslatePipe } from "@ngx-translate/core";
import { IonicModule } from "@ionic/angular";
@Component({
    selector: "app-pay-confirmation",
    templateUrl: "./pay-confirmation.component.html",
    styleUrls: ["./pay-confirmation.component.scss"],
    standalone: true,
    imports: [IonicModule, TranslatePipe],
})
export class PayConfirmationComponent implements OnInit {
  constructor(private router: Router, private authService: AuthService, public translate: TranslateService) {
    this.authService?.selectedlanguage$?.subscribe(
      (l) => {
        if (l) {
          translate.use(l ? l : "en");
        }
      },
      (err) => {
        return err;
      }
    );
  }

  ngOnInit() {}

  goToCompleteRegistrationPage() {
    this.router.navigate(["/completeRegistration"]);
  }
}
